"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mixinPanel = _interopRequireDefault(require("@/libs/flowable/common/mixinPanel"));
var _mixinExecutionListener = _interopRequireDefault(require("@/libs/flowable/common/mixinExecutionListener"));
var _parseElement = require("@/libs/flowable/common/parseElement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  mixins: [_mixinPanel.default, _mixinExecutionListener.default],
  data: function data() {
    return {
      formData: {}
    };
  },
  computed: {
    formConfig: function formConfig() {
      return {
        inline: false,
        item: [{
          xType: 'input',
          name: 'id',
          label: '节点 id',
          rules: [{
            required: true,
            message: 'Id 不能为空'
          }]
        }, {
          xType: 'input',
          name: 'name',
          label: '节点名称'
        }, {
          xType: 'input',
          name: 'documentation',
          label: '节点描述'
        }, {
          xType: 'slot',
          name: 'executionListener',
          label: '执行监听器'
        }, {
          xType: 'switch',
          name: 'async',
          label: '异步',
          activeText: '是',
          inactiveText: '否'
        }]
      };
    }
  },
  watch: {
    'formData.async': function formDataAsync(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:async': val
      });
    }
  },
  created: function created() {
    this.formData = (0, _parseElement.commonParse)(this.element);
  }
};